import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useUserAvatarStyles = makeStyles((theme: Theme) => {
	const { permanentBreakpoint } = theme.navDrawer
	return createStyles({
		root: {
			alignItems: "baseline",
			display: "flex",
		},
		avatar: {},
		name: {
			display: "none",
			[permanentBreakpoint]: {
				display: "inline"
			}
		},
		badgeGreen: {
			backgroundColor: theme.palette.success.main,
			color: theme.palette.success.main
		},
		badgeError: {
			backgroundColor: theme.palette.error.main,
			color: theme.palette.error.main
		},
	});
});
